module.exports = __webpack_public_path__ + "img/about_image1.9b5a2f2d.png";